@if (baseSite$(); as baseSite) {
  @if (language$(); as language) {
    <ng-container
      [ngTemplateOutlet]="!textOnly() ? btnAndFlag : text"
      [ngTemplateOutletContext]="{ language: language, baseSite: baseSite }"
    >
    </ng-container>
  }
}

<ng-template #btnAndFlag let-language="language" let-baseSite="baseSite">
  @if (!inMobileMenu()) {
    <img
      width="20px"
      height="14px"
      [src]="imageUrl()"
      loading="lazy"
      alt="{{ baseSite?.country?.name }}"
    />
  }
  <button
    #languageButton
    class="btn"
    [class.active]="isActive()"
    (click)="openLanguageSelector()"
    tabindex="0"
    (mousedown)="handleMouseDown()"
    [attr.aria-label]="
      'Change language. Current: ' +
      baseSiteNativeName() +
      ' - ' +
      language.nativeName
    "
    [attr.aria-haspopup]="true"
    [attr.aria-expanded]="false"
    tabindex="0"
  >
    @if (inMobileMenu()) {
      <img
        width="20px"
        height="14px"
        [src]="imageUrl()"
        loading="lazy"
        alt="{{ baseSite?.country?.name }}"
        class="mobile-flag"
      />
    }
    {{ baseSiteNativeName() }} - {{ language.nativeName }}
  </button>
</ng-template>

<ng-template #text let-language="language">
  <span class="{{ cssClassForText() }}">
    {{ baseSiteNativeName() }} - {{ language.nativeName }}
  </span>
</ng-template>
